/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, LinkButton } from '@blend/enterprise-components';
import * as utils from '../utils';
import { BlendBridge } from 'blb-types/blendBridge';
import { downloadDocument } from 'blb-api/loans';
import { useToasts } from 'blb-components/AuthenticatedApp/Toast';

const styles = StyleSheet.create({
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  titleWrapper: {
    display: 'flex',
    marginBottom: 4,
    maxWidth: '100%',
    overflow: 'ellipsis',
    width: 'fit-content',
  },
});

export interface Props {
  document: BlendBridge.API.Document;
  loan: BlendBridge.API.Loan;
}

export const DocumentNameColumn: React.FC<Props> = ({ document, loan }) => {
  const Toaster = useToasts();
  const fileName = document.fileNameOverride || document.displayFileName;

  const openDocumentInNewTab = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    downloadDocument({ documentId: document._id, documentTypeLabel: document.type, loanId: loan.loanId, Toaster });
  };

  return (
    <div className={css(styles.columnContainer)}>
      <div className={css(styles.titleWrapper)} data-it="DocumentNameColumn-FileName">
        {!utils.hasVirus(document) ? (
          <LinkButton
            btnSize="sm"
            id="document-file-name-link"
            label={fileName}
            onClick={openDocumentInNewTab}
            useEllipsis
          />
        ) : (
          <Text colorName="NIGHT_80" ellipsis fontSize="sm">
            {`${fileName} (Virus Detected)`}
          </Text>
        )}
      </div>
    </div>
  );
};
